import { multiply } from 'ramda';

export const formatCurrency = (price, multiplyBy = false) => {
  if (multiplyBy) price = multiply(multiplyBy, price);

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
};
